<script>

    import { locale } from 'svelte-i18n';

    import Icon from './Icon.svelte';
    import flagEn from '../assets/flags/en.svg?raw';
    import flagNl from '../assets/flags/nl.svg?raw';


    function changeLanguage(language) {
        locale.set(language);
    }

</script>

<div>
    {#if $locale === 'nl'}
        <button onclick={() => changeLanguage('en')} aria-label="Switch to English">
            <Icon data={flagEn} /> Prefer English?
        </button>
    {:else}
        <button onclick={() => changeLanguage('nl')} aria-label="Schakel naar Nederlands">
            <Icon data={flagNl} /> Liever Nederlands?
        </button>
    {/if}
</div>

<style>

    div {
        margin-left: auto;
        position: absolute;
        bottom: -2.2em;
        right: 3em;
        z-index: 2;
    }

    @media (max-width: 600px) {
        div {
            right: 2em;
        }
    }

    button {
        appearance: none;
        border: none;
        background: none;
        color: var(--text-color);
        font-size: 0.65rem;
        cursor: pointer;

        filter: saturate(0);

        display: flex;
        align-items: center;
        padding: 0.25em 0.5em;
        margin: -0.25em -0.5em;
        border-radius: 4px;
        transition: background-color 0.2s ease, filter 0.2s ease;
        outline: none;
    }

    button:hover {
        filter: saturate(1);
    }

    button:focus-visible {
        background-color: rgba(0, 0, 0, 0.35); /* Fallback */
        filter: saturate(1);
    }

    @supports (color: color-mix(in srgb, red 50%, blue)) {
        button:focus-visible {
            background-color: color-mix(in srgb, var(--accent-background) 35%, transparent);
        }
    }

    button :global(svg) {
        margin-right: 0.3em;
        width: 1.6em;
    }


</style>